import { Controller } from 'react-hook-form';
import { InputMask } from 'primereact/inputmask';
import { US_PHONE_MASK, isValidPhoneDigits } from '../../utils/phone';

export default function PhoneField({ control, name = 'phone', label = 'Phone', required = false }) {
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        validate: (value) => {
          const digits = value || '';
          if (!digits) return required ? 'Phone number is required.' : true;
          return isValidPhoneDigits(digits) || 'Enter a valid US phone number (10 digits).';
        },
      }}
      render={({ field, fieldState }) => (
        <div className="field">
          <label htmlFor={name}>{label}</label>
          <InputMask
            id={name}
            mask={US_PHONE_MASK}
            unmask
            autoClear={false}
            className={`w-full ${fieldState.invalid ? 'p-invalid' : ''}`}
            value={field.value || ''}
            onChange={(e) => field.onChange(e.value || '')}
            onBlur={field.onBlur}
          />
          <small className="p-error" style={{ display: 'block', minHeight: '1.25rem', marginTop: 2 }}>
            {fieldState.error?.message ?? ''}
          </small>
        </div>
      )}
    />
  );
}
